import { OrderInvalidEnum } from 'enums'
import { t } from 'i18next'
import { CustomerPaymentTypeEnum } from 'graphQL/hatostore/generate/operations'
import { PaymentTypeEnum } from 'graphQL/dinein/generate/operations'

export const getPaymentMethodWording = (_paymentMethodType: CustomerPaymentTypeEnum) => {
  switch (_paymentMethodType) {
    case CustomerPaymentTypeEnum.BankTransfer:
      return 'Bank transfer / PromptPay'
    case CustomerPaymentTypeEnum.CashOnDelivery:
      return 'Cash on delivery'
    case CustomerPaymentTypeEnum.OmiseCreditCard:
      return 'Credit Card'
    default:
      return ''
  }
}

export const getMappingExtensionFromInputFileType = (fileType: string) => {
  switch (fileType) {
    case 'image/jpeg':
      return 'jpg'
    case 'image/png':
      return 'png'
    case 'image/gif':
      return 'gif'
    case 'image/webp':
      return 'webp'
    case 'image/heif':
      return 'heif'
    default:
      return ''
  }
}

export const getOrderInvalidWarningText = (orderInvalids: string[]) => {
  if (orderInvalids.includes(OrderInvalidEnum.InvalidBeingCheckedOut)) {
    return t('dineInInvalidBeignCheckedout')
  }
  if (
    orderInvalids.includes(OrderInvalidEnum.InvalidExternalCoupon) ||
    orderInvalids.includes(OrderInvalidEnum.InvalidPromotion)
  ) {
    return t('modalWarningInvalidCouponTitle')
  }
  if (orderInvalids.includes(OrderInvalidEnum.InvalidLineItem)) {
    return t('dineInLineItem')
  }
  if (orderInvalids.includes(OrderInvalidEnum.InvalidMemberCoupon)) {
    return t('modalWarningInvalidCouponTitle')
  }
  if (orderInvalids.includes(OrderInvalidEnum.InvalidMinimumLineItemTotal)) {
    return t('dineInMinimumOrderWarning')
  }
  if (orderInvalids.includes(OrderInvalidEnum.InvalidMinimumTotal)) {
    return t('dineInMinimumOrderWarning')
  }
  return ''
}

export const filterDineInPaymentMethods = (paymentMethods: CustomerPaymentTypeEnum[]) => {
  const unsupportedDineInPaymentMethods = [CustomerPaymentTypeEnum.CashOnDelivery, CustomerPaymentTypeEnum.BankTransfer]
  return paymentMethods.filter((paymentMethod) => !unsupportedDineInPaymentMethods.includes(paymentMethod))
}

export const filterBuffetPaymentMethods = (paymentMethods: PaymentTypeEnum[]) => {
  const unsupportedDineInPaymentMethods = [PaymentTypeEnum.Cash, PaymentTypeEnum.BankTransfer]
  return paymentMethods.filter((paymentMethod) => !unsupportedDineInPaymentMethods.includes(paymentMethod))
}
